import Image from 'next/image';

type Variant = 'portrait' | 'landscape';

interface Props {
  variant: Variant;
}

const variantNoiseLookup = {
  portrait: 'bg-card-noise-vertical.webp',
  landscape: 'bg-card-noise-horizontal.webp',
};

export const NoiseImage = ({ variant }: Props) => {
  return (
    <Image
      src={`/images/loyalty/${variantNoiseLookup[variant]}`}
      fill
      style={{ objectFit: 'cover', mixBlendMode: 'soft-light' }}
      alt="Noise overlay"
      priority
      unoptimized
    />
  );
};

const variantGradientLookup = {
  portrait: 'bg-card-gradient-vertical.webp',
  landscape: 'bg-card-gradient-horizontal.webp',
};

export const GradientImage = ({ variant }: Props) => {
  return (
    <Image
      src={`/images/loyalty/${variantGradientLookup[variant]}`}
      fill
      style={{ objectFit: 'cover' }}
      alt="Gradient overlay"
      priority
      unoptimized
    />
  );
};
